import { useQuery } from '@tanstack/react-query';
import { type AxiosResponse } from 'axios';

import { fetchData } from '@framework/api/apiCalls';
import { api } from '@framework/constants/endpoints';
import { ServerStateKeys } from '@framework/constants/serverStateKeys';

import { type ApiResponse } from '@type/api';
import { type Member } from '@type/members';

type UseMemberParams = {
    id?: string;
    organisationId?: string;
    noRedirect?: boolean;
};

type UseMemberOptions = {
    staleTime?: number;
};

const fetchMember = async (params: UseMemberParams) => {
    if (!params.id) {
        return undefined;
    }

    const response: AxiosResponse<ApiResponse<Member>> = await fetchData(api.member(params.id), {
        params: {
            related: true,
            readonlyFields: true,
            ...(params?.organisationId ? { organisationId: params.organisationId } : {})
        },
        noRedirect: Boolean(params.noRedirect)
    });
    return response.data.results;
};

const useMember = (params: UseMemberParams, options?: UseMemberOptions) => {
    return useQuery({
        queryKey: [ServerStateKeys.Member, params],
        queryFn: () => fetchMember(params),
        enabled: !!params.id,
        staleTime: options?.staleTime
    });
};

export default useMember;
